const typography = {
  fontFamily: 'Poppins', // Default font family
  fontWeightLight: 300, // Light weight
  fontWeightRegular: 400, // Regular weight
  fontWeightMedium: 600, // Medium weight
  fontWeightBold: 700, // Bold weight
};

export default typography;
